import { render, staticRenderFns } from "./BeneficioList.vue?vue&type=template&id=631c6f09&"
import script from "./BeneficioList.vue?vue&type=script&lang=js&"
export * from "./BeneficioList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports